import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";

/** 
 * 自定义组件参考文档
 * https://cn.vuejs.org/v2/guide/components-registration.html
*/
import Test from "./test/";
import imgList from "./imgList";
import imgTabs from "./imgTabs";
import $Echart from "../echart/common";
import { KEY_COMPONENT_NAME } from "../echart/variable";
export default (function () {
  var list = [Test, imgList, imgTabs];
  var result = {}; //循环注册组件

  list.forEach(function (ele) {
    ele.mixins = [$Echart];
    result["".concat(KEY_COMPONENT_NAME).concat(ele.name)] = ele;
  });
  return result;
})();